export const environment = {
  production: false,
  base: 'https://pagofacilapiqa.nelumbo.com.co/api-pagofacil',
  captcha: '6LdNjDwhAAAAAFUgB-dUwei2kp2IoFMn1cI6ubj_',
};
